import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import Njc5Form from "../../components/reports/Njc5Form";

// Print page for NJC/MCPJ/5: /reports/print/njc5/:eventtype/:judgeid/:divisionid/:lastdate
const toYmd = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`;

function Njc5Report() {
  const { eventtype, judgeid, divisionid, lastdate } = useParams();
  const { token, setIsExpired } = useContext(ShareContext);
  const [rows, setRows] = useState([]);
  const [header, setHeader] = useState({});
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onLoad = async () => {
    setLoading(true);
    try {
      const [y, m] = (lastdate || "").split("-").map(Number);
      const fromDate = y ? toYmd(new Date(y, Math.floor((m - 1) / 3) * 3, 1)) : null;
      const resp = await fetch(`${Constants.apiUrl}/report/judgement-pending-cases/0/0`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          judgeId: Number(judgeid) > 0 ? Number(judgeid) : null,
          divisionId: Number(divisionid) > 0 ? Number(divisionid) : null,
          fromDate,
          toDate: lastdate || null,
          eventType: eventtype === "all" ? "" : eventtype,
        }),
      });
      const data = await resp.json();
      setLoading(false);
      if (data.code === 0) {
        setRows(data.items || []);
        setHeader(data.header || {});
      } else if (data.code === -10) {
        setIsExpired(true);
      } else {
        setErr(data.status || "Failed to load report");
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
      setErr(Constants.serverErr);
    }
  };

  return (
    <div style={{ background: "#fff", padding: 24 }}>
      <div className="no-print" style={{ marginBottom: 12 }}>
        <span className="specialaction" style={{ cursor: "pointer" }} onClick={() => window.print()}>
          Print
        </span>
      </div>
      {err && <div className="error-message">{err}</div>}
      <Njc5Form header={header} rows={rows} />
      <BackLoader open={loading} />
    </div>
  );
}

export default Njc5Report;
